import { styled } from '@mui/material';

import AcadlyUserAvatar from '../../components/UserAvatar';

export const UserAvatar = styled(AcadlyUserAvatar)(({ theme }) => ({
  width: 24,
  height: 24,
}));
